import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/theorem.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
		Manuscript held by G. W. Leibniz Bibliothek, Hanover<br />
		Shelfmark LH 35, 14, 1 Bl. 29r<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}
		Date: after 13 August 1696<br /><br />
        Translated from the Latin<br /><br /> 
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (174k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Theorem: Two and Two is Four</title>
            <meta name="description" content="An English translation of THEOREM: TWO AND TWO IS FOUR by Gottfried Wilhelm Leibniz, from after 13 August 1696" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: THEOREM: TWO AND TWO IS FOUR</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 <small>This short piece was written on the back of an envelope that had been addressed to Leibniz as &quot;privy counsellor&quot;, indicating that it was written after Leibniz's appointment to that position on 13 August 1696. The paper bears no watermark that would allow for a narrower dating.</small><br /><br /><br />
		        [<b>LH 35, 14, 1 Bl. 29r</b>]<br /><br />
                <center>Theorem<br />
Two and Two is Four</center><br />
<var>Definitions</var><br />
(1) <var>Two</var> is one and one<br />
(2) <var>Three</var> is two and one<br />
(3) <var>Four</var> is three and one<br /><br />

<center>Demonstration</center><br />

Two and <var>two</var> is two and <var>one and one</var>, by definition 1.<br />
<var>Two and one</var> and one is <var>three</var> and one, by definition 2.<br />
<var>Three and one</var> is <var>four</var>, by definition 3.<br />
Therefore, two and two is four&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Q.E.D.
                <br /><br /><br />
                &#169; Lloyd Strickland 2025
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
